





import { defineComponent } from "@nuxtjs/composition-api";
import CmsBlocks from "components/theme/Content/CmsBlocks.vue";
import { SfButton } from "@storefront-ui/vue";

export default defineComponent({
  name: "TopBar",
  props: {
    identifier: {
      type: String,
      default: "",
    },
    background: {
      type: String,
      default: "var(--yellow)",
    },
  },
  methods: {
    hide() {
      this.$emit("hideTopBar");
    },
  },
  components: {
    CmsBlocks,
    SfButton,
  },
});
